import React from 'react'
import styled from 'styled-components'
import ParkingImage from '../assets/images/parking.svg'

const DivStyled = styled.div`
  width: 90px;
  height: 90px;
  min-width: 90px;
  border: 2px solid var(--yellow);
  border-radius: 47px;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 55px;
    height: 55;
  }
`

const ParkingIcon = () => (
  <DivStyled>
    <img src={ParkingImage} />
  </DivStyled>
)

export default ParkingIcon
